export default (type) => {
  const pageType = window.tc_vars.page_type;
  if (typeof window.tC.event.share === "function") {
    window.tC.event.share(this, {
      method: type,
      content_type: pageType,
    });
  }
};
